var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "react-query";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReservationStatus } from "../../models/reservation/reservation.model";
import { useCurrentSector } from "../../utils/hooks/sector/useSectors";
import { ReservationAggregationService } from "../../services/aggregation/reservationAggregation.service";
import { formatFullDMY } from "../../utils/date.util";
import { ResourceDisplayReferenceElement } from "../uiElements/ResourceElement";
var ReservationPastVisits = function (props) {
    var _a, _b, _c, _d;
    var t = useTranslation().t;
    var sector = useCurrentSector();
    var pastReservationsForSector = useQuery(['pastReservationsForSector', (_a = props.profile) === null || _a === void 0 ? void 0 : _a.id, sector === null || sector === void 0 ? void 0 : sector.id], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, visits;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(sector === null || sector === void 0 ? void 0 : sector.id) || !((_a = props.profile) === null || _a === void 0 ? void 0 : _a.id))
                        return [2 /*return*/, { visits: [], total: 0 }];
                    return [4 /*yield*/, ReservationAggregationService.listReservations({
                            profileIds: [(_b = props.profile) === null || _b === void 0 ? void 0 : _b.id],
                            sectorIds: [sector === null || sector === void 0 ? void 0 : sector.id],
                            status: [
                                ReservationStatus.CONFIRMED,
                                ReservationStatus.ACTIVE,
                                ReservationStatus.COMPLETED
                            ],
                            // A visit is "past" by its end date, not by status: dashboard-created reservations
                            // never get COMPLETED (only PMS checkouts set it), so they stay CONFIRMED/ACTIVE forever.
                            expectedEnd: { start: new Date(0), end: new Date() },
                            limit: {
                                offset: 0,
                                limit: 2,
                                sort: [{ field: "expectedEndDate", direction: "DESC" }]
                            }
                        })];
                case 1:
                    response = _d.sent();
                    visits = response.content || [];
                    return [2 /*return*/, { visits: visits, total: (_c = response.totalElements) !== null && _c !== void 0 ? _c : visits.length }];
            }
        });
    }); });
    var pastVisits = ((_b = pastReservationsForSector.data) === null || _b === void 0 ? void 0 : _b.visits) || [];
    var hiddenCount = Math.max(((_d = (_c = pastReservationsForSector.data) === null || _c === void 0 ? void 0 : _c.total) !== null && _d !== void 0 ? _d : 0) - pastVisits.length, 0);
    if (!pastVisits.length) {
        return (_jsx(Typography, __assign({ variant: 'body2' }, { children: t('No past visits') })));
    }
    var renderPastVisit = function (visit) {
        var date = formatFullDMY(visit.startDate);
        return (_jsxs(Stack, __assign({ direction: "row", gap: 0.5, alignItems: "center", flexWrap: "wrap", useFlexGap: true }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "text.secondary" }, { children: date })), visit.resources.map(function (resource) { return (_jsx(ResourceDisplayReferenceElement, { resource: resource }, resource.id)); })] }), visit.id));
    };
    return (_jsxs(Stack, __assign({ gap: 0.5, alignItems: 'flex-start' }, { children: [pastVisits.map(function (info) { return renderPastVisit(info); }), hiddenCount > 0 && (_jsx(Typography, __assign({ variant: "body2", color: "text.secondary" }, { children: "\u2026 ".concat(t('+{{total}} more', { total: hiddenCount })) })))] })));
};
export default ReservationPastVisits;
